'use client';

import HiraokaBlogCover from '@/components/HiraokaBlogCover';
import ItagakiBlogCover from '@/components/ItagakiBlogCover';
import LessonCourse from '@/components/LessonCourse';
import UedaBlogCover from '@/components/UedaBlogCover';
import { clickVisitCoursePageLink } from '@/utils/analytics/log-event';

type Props = {
  categorySlug: string;
};

const Component: React.FC<Props> = ({ categorySlug }) => {
  const element = () => {
    switch (categorySlug) {
      case 'hiraoka-yoshihiro':
        return (
          <>
            <HiraokaBlogCover />
            <LessonCourse
              courseId="hiraoka-correct-drive"
              onClick={() => clickVisitCoursePageLink('hiraoka_lesson_course')}
            />
          </>
        );
      case 'itagaki-koji':
        return (
          <>
            <ItagakiBlogCover />
            <LessonCourse
              courseId="itagaki-overcome-receive"
              onClick={() => clickVisitCoursePageLink('itagaki_lesson_course')}
            />
          </>
        );
      case 'ueda-jin':
        return (
          <>
            <UedaBlogCover />
          </>
        );
      default:
        return <></>;
    }
  };

  return <div children={element()} className="grid gap-y-5" />;
};

export default Component;
